import { render, staticRenderFns } from "./ModalOpenSpeakingTest.vue?vue&type=template&id=4573534a&scoped=true"
import script from "./ModalOpenSpeakingTest.vue?vue&type=script&lang=js"
export * from "./ModalOpenSpeakingTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573534a",
  null
  
)

export default component.exports